import { useEffect, useRef } from "react";
import styles from "./Innerhtml.module.css";

const Innerhtml = ({ data }) => {
  const mainRef = useRef(null);

  useEffect(() => {
    const styleTablesAndImages = () => {
      if (mainRef.current) {

        const tables = mainRef.current.querySelectorAll("table");
        const images = mainRef.current.querySelectorAll("img");

        tables.forEach((table) => {
          const parentDiv = document.createElement("div");
          parentDiv.classList.add(styles.tableWrapper);
          table.parentNode.insertBefore(parentDiv, table);
          parentDiv.appendChild(table);
          table.style.width = "100%";
        });

        images.forEach((img) => {
          img.removeAttribute("height");
          img.removeAttribute("width");

          const parentDiv = document.createElement("div");
          parentDiv.classList.add(styles.imageWrapper);
          img.parentNode.insertBefore(parentDiv, img);
          parentDiv.appendChild(img);
          img.style.maxWidth = "100%";
        });
      }
    };

    styleTablesAndImages();
  }, [data]); // Re-run when data changes

  return (
    <div>
      {data && (
        <div
          ref={mainRef}
          className={styles.dataContent}
          dangerouslySetInnerHTML={{ __html: data }}
        />
      )}
    </div>
  );
};

export default Innerhtml;
